import styled from '@emotion/styled';

export const NoDataContainer = styled.div`
  text-align: center;
  opacity: 0.2;
  font-size: 20px;
  margin: 100px 0;
`;
